// 이전 월의 1일자 반환
export const getPrevMonthStartDayFromDahedDateString = (
  dateString: string
): Date => {
  const [year, month, day] = dateString.split('-').map(Number); // YYYY-MM-DD를 분리하여 숫자형으로 변환

  // 이전 달의 1일 계산
  const newDate = new Date(year, month - 1 - 1, 1); // month-1로 이전 달을 계산하고, 1일로 설정

  return newDate;
};

// 다음 월의 1일자 반환
export const getNextMonthStartDayFromDahedDateString = (
  dateString: string
): Date => {
  const [year, month, day] = dateString.split('-').map(Number); // YYYY-MM-DD를 분리하여 숫자형으로 변환

  // 다음 달의 1일 계산
  const newDate = new Date(year, month, 1); // month로 다음 달을 계산하고, 1일로 설정

  return newDate;
};
